<template>
    <div v-if="invoice_id">
        <div style="margin-top: 5px; font-size: 12px;">
            <div v-if="items_being_loaded">
                <div>
                    <loading 
                    :active="true" 
                    :can-cancel="false" 
                    :is-full-page="false">
                    </loading>
                </div>
            </div>
            <div v-else-if="items_being_loaded == false">
                <div v-if="filteredItems.length == 0">
                    <b-alert variant="secondary" show style="font-size: 12px;">
                        {{ noItemsMessage }}
                    </b-alert>
                </div>

                <div v-else>
                    <b-container fluid class="bv-example-row" style="width: 100%; margin-top: 10px;" v-for="item,ridx in filteredItems" v-bind:key="ridx" >
                        <!-- STORE CREDIT ITEM -->
                        <div v-if="item.detail.type == 'return'" class="store-credit-item">
                            <div><strong>STORE CREDIT</strong></div>
                            <div>AT: {{item.detail.ts}}</div> 
                            <div>ISSUED BY: {{ (item.detail.created_by || '').toUpperCase()}}</div>
                            <b-row style="padding: 0px;">
                                <b-col style="border: 0px solid; padding: 0px;" cols="8" >
                                    <table style="width: 100%">
                                        <thead>
                                            <tr>
                                                <td class="rhead" style="width: 200px;">
                                                    PRODUCT NAME
                                                </td>
                                                <td class="rhead" style="width: 150px;">
                                                    PRODUCT SKU
                                                </td>
                                                <td class="rhead" style="width: 35px;">
                                                    QTY
                                                </td>
                                                <td class="rhead" style="width: 50px;">
                                                    AMOUNT
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="ritem,rtidx in item.ritems" v-bind:key="rtidx">
                                                <td class="rval">
                                                    {{ritem.product_name}}
                                                </td>
                                                <td class="rval">
                                                    {{ritem.product_sku}}
                                                </td>
                                                <td class="rval">
                                                    {{ritem.return_quantity}}
                                                </td>
                                                <td class="rval">
                                                    $ {{(ritem.selling_price  || 0.0).toFixed(2)}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-col>
                                <b-col style="border: 0px solid;">
                                    <table style="width: 100%">
                                        <thead>
                                            <tr>
                                                <td class="rhead">DELIVERY</td>
                                                <td class="rhead">SETUP</td>
                                                <td class="rhead">WARRANTY</td>
                                                <td class="rhead">SLS TAX</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="rval">$ {{ (item.detail.total_refunded_delivery || 0.0).toFixed(2)}}</td>
                                                <td class="rval">$ {{ (item.detail.total_refunded_setup || 0.0).toFixed(2)}}</td>
                                                <td class="rval">$ {{(item.detail.total_refunded_warranty || 0.0).toFixed(2)}}</td>
                                                <td class="rval">$ {{(item.detail.total_refunded_sales_tax || 0.0).toFixed(2)}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <b-card-text style="padding: 5px; font-weight: bold;">
                                        TOTAL:  $ {{ ( get_total_for_a_refund(item.detail) || 0.0 ).toFixed(2)}}
                                    </b-card-text>
                                </b-col>
                            </b-row>
                            <hr />
                        </div>

                        <!-- REFUND ITEM -->
                     <div v-else-if="item.detail.type == 'refund'" class="refund-item">
    <div><strong>REFUND</strong></div>
    <div>AT: {{item.detail.ts}}</div> 
    <div>ISSUED BY: {{ (item.detail.processing_user || '').toUpperCase()}}</div>
    <b-row style="padding: 0px;">
        <b-col style="border: 0px solid; padding: 0px;" cols="8" >
            <table style="width: 100%">
                <thead>
                    <tr>
                        <td class="rhead" style="width: 35px;">PAYMENT METHOD</td>
                        <td class="rhead" style="width: 50px;">AMOUNT</td>
                        <td class="rhead" style="width: 100px;">DETAILS</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ritem,rtidx in item.ritems" v-bind:key="rtidx">
                        <td class="rval">{{ (ritem.value || 'N/A').toUpperCase() }}</td>
                        <td class="rval">$ {{ parseFloat(ritem.issue_amount || 0.0).toFixed(2) }}</td>
                        <td class="rval">
                            <span v-if="ritem.value === 'cc' && ritem.name">
                                Card: ****{{ ritem.name }}
                            </span>
                            <span v-else-if="ritem.value === 'check' && ritem.check_number">
                                Check #: {{ ritem.check_number }}
                            </span>
                            <span v-else-if="ritem.value === 'finance' && ritem.name">
                                {{ ritem.name }}
                            </span>
                            <span v-else-if="ritem.notes">
                                {{ ritem.notes }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-col>
        <b-col style="border: 0px solid;">
            <b-card-text style="padding: 5px; font-weight: bold;">
                TOTAL: $ {{ (parseFloat(item.detail.amount) || 0.0).toFixed(2)}}
            </b-card-text>
        </b-col>
    </b-row>
    <hr />
</div>
                    </b-container>
                </div>
            </div>
            <div v-else></div>
        </div>
    </div>
</template>

<script>
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    
    export default {
        name: "RefundsSummary",
        props: ["viewdata"],
        components: {Requestor, Loading},
        data: function(){
            return {
                packet: {},
                invoice_id: null,
                items: [],
                items_being_loaded: null,
                return_reasons: [
                    {value: 0, text: "OTHER"},
                    {value: 1, text: "ITEM DAMAGED"},
                    {value: 2, text: "ITEM INCOMPLETE"},
                ],
                is_delivered: [
                    {value: false, text: "NO"},
                    {value: true, text: "YES"}
                ],
            }
        },
        computed: {
            filterType() {
                return this.viewdata.filterType || 'all'; // 'all', 'refund', 'return'
            },
            filteredItems() {
                if (!this.items || this.items.length === 0) return [];
                
                if (this.filterType === 'all') {
                    return this.items;
                } else if (this.filterType === 'refund') {
                    return this.items.filter(item => item.detail.type === 'refund');
                } else if (this.filterType === 'return') {
                    return this.items.filter(item => item.detail.type === 'return');
                }
                return this.items;
            },
            noItemsMessage() {
                switch (this.filterType) {
                    case 'refund': return 'NO REFUNDS FOUND';
                    case 'return': return 'NO STORE CREDITS FOUND';
                    default: return 'NO REFUNDS HISTORY FOUND';
                }
            }
        },
        methods: {
            fetch_init: function(){
                let path = "/api/sales/get_refunds_history/"
                let data = {invoice_id: this.invoice_id}
                let that = this;

                let s = function(response) {
                    console.log(response, 'uee')
                    if (response.data.result) {
                        let items = response.data.result;        
                        that.items = items
                        that.$emit("refunds-history", that.items);
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading refunds history.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }

                this.items = []
                this.items_being_loaded = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            get_total_for_a_refund: function(item){
                let val =
                (item.total_refunded_item_amount || 0.0)+
                (item.total_refunded_delivery || 0.0)+
                (item.total_refunded_setup || 0.0)+
                (item.total_refunded_warranty || 0.0)+
                (item.total_refunded_sales_tax || 0.0) ;
                return val
            }
        },
        created: function(){
            if (this.viewdata.invoice_id){
                this.invoice_id = this.viewdata.invoice_id;
                this.packet= this.viewdata.packet;
                this.fetch_init();
            }
        }
    }
</script>

<style scoped>
    @media print {
        .separate {
            page-break-after: always;
        }
    }

    .rhead {
        font-size: 12px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .rval {
        font-size: 12px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
    }

    .refund-item {
        border-left: 4px solid #dc3545;
        padding-left: 10px;
        margin-bottom: 15px;
    }

    .store-credit-item {
        border-left: 4px solid #28a745;
        padding-left: 10px;
        margin-bottom: 15px;
    }

    h3 {
        margin: 0px;
    }

    .input-txt {
        border: 0px; 
        font-weight: normal; 
        color: #2c3e50; 
        display: inline; 
        padding: 0px; 
        margin: 0px;
    }

    .ipt_tdhr {
        border: 2px solid black;
    }

    table.report-container {
        page-break-after:always;
    }

    thead.report-header {
        display:table-header-group;
    }

    tfoot.report-footer {
        display:table-footer-group;
    }

    .tabl {width:100%;border:1px solid blue;display:table}
    .trow {height:40px;display:table-row}
    .tcell {border:1px solid black;display:table-cell}
</style>


// WEBPACK FOOTER //
// src/components/importables/Refundsummarysales.vue